import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { isBlank } from '@app/utils/string';

export const NUMBER_REGEX = /^\d+$/;
export const OPTIONAL_PLUS_NUMBER_REGEX = /^\+?\d+$/;
export const PHONE_NUMBER_REGEX = /^\+\d+$/;
export const PLUS_E164_REGEX = /^\+\d{5,}/;

export const NotBlankValidator = Validators.pattern(/[^\s]/);
export const NumberValidator = Validators.pattern(NUMBER_REGEX);
export const OptionalPlusNumberValidator = Validators.pattern(OPTIONAL_PLUS_NUMBER_REGEX);
export const PhoneNumberValidator = Validators.pattern(PHONE_NUMBER_REGEX);
export const PlusE164NumberValidator = Validators.pattern(PLUS_E164_REGEX);

export function RequiredValidator(control: AbstractControl): ValidationErrors | null {
  let errors = null;

  const requiredError = Validators.required(control);
  const notBlankError = NotBlankValidator(control);

  if (requiredError != null) {
    if (notBlankError != null) {
      errors = {
        ...requiredError,
        ...notBlankError,
      };
    } else {
      errors = requiredError;
    }
  } else {
    errors = notBlankError;
  }

  return errors;
}

export function RequireAnyValidator(...name: string[]) {
  let validated = false;

  return function (control: AbstractControl): ValidationErrors {
    let errors = null;

    if (control != null && control.parent != null && !validated) {
      validated = true;

      const parent = control.parent;
      const requiredControls: AbstractControl[] = name
        .map((name) => parent.controls[name])
        .filter((_) => _ !== control);

      const isValid = name.some(
        (name) => !!parent.controls[name].value && isBlank(parent.controls[name].value) === false
      );

      requiredControls.forEach((control) => control.updateValueAndValidity({ onlySelf: true }));

      validated = false;

      if (!isValid) {
        errors = {
          anyOfRequired: name,
        };
      }
    }

    return errors;
  };
}
